import React, { useState } from 'react'

import 'rc-steps/assets/index.css'

import { cn } from 'utils/classMerge'
import { sanitizeDomain } from 'utils/functions'
import { palette } from 'styles/variables'
import { translate } from 'utils/translation'
import { UberInputField } from 'components/input/InputField'
import { NavButton } from 'containers/AddProjectModal/steps/styled'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
} from 'utils/kissmetrics'

import { StepWrapper, StepContent } from '../components'

interface SearchProjectProps {
  domain: string
  handleChange: (
    field: string,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void
  invalidDomain: string | null
  validate: () => Promise<{ invalidDomain: boolean }>
  onSubmit: (domain: string) => void
  onClose: () => void
}

export const SearchProject: React.FC<SearchProjectProps> = ({
  domain,
  handleChange,
  invalidDomain,
  validate,
  onSubmit,
  onClose,
}) => {
  const [isValidating, setIsValidating] = useState(false)

  return (
    <StepWrapper className={cn('tw-max-w-[480px]')}>
      <StepContent>
        <div className="tw-flex tw-w-full md:tw-flex-nowrap tw-flex-wrap">
          <UberInputField
            data-testid="add-project-step1-name"
            placeholder={translate('placeholder_website_url')}
            name="domain"
            value={domain}
            onChange={handleChange('domain')}
            invalidMessage={invalidDomain}
            height="48px"
            backgroundColor={palette.dimBlue}
            styles={{ width: '100%' }}
            inputRef={null}
            rightElement={null}
          />
        </div>
        <div className="tw-flex tw-items-center tw-justify-center tw-mt-6 md:tw-flex-row tw-flex-col">
          {/* @ts-ignore TODO: Wait for TS component update */}
          <NavButton
            testId="add-project-step1-close"
            color="grey"
            onClick={onClose}
            tag={translate('close')}
          />

          {/* @ts-ignore TODO: Wait for TS component update */}
          <NavButton
            testId="add-project-step1-next"
            isLoading={isValidating}
            color={sanitizeDomain(domain) ? 'orange' : 'secondary'}
            onClick={() => {
              if (isValidating) return
              setIsValidating(true)
              validate().then(({ invalidDomain: isDomainValid }) => {
                if (!isDomainValid) {
                  kissmetricsRecordingEvent(
                    KISSMETRICS_TRACK_EVENTS.project_creation_actions,
                    {
                      'project flow action': 'URL and name text',
                    },
                  )
                  onSubmit(domain)
                }
                setIsValidating(false)
              })
            }}
            tag={translate('next')}
            disabled={!!invalidDomain}
          />
        </div>
      </StepContent>
    </StepWrapper>
  )
}
